<template>
  <div>
    <div class="alert-large alert-large-info"
         v-if="bookingInPersonDayBefore
         && bookingAppearanceInPerson
         && !bookingInPersonCompleted
         && !talentConfirmedInPersonAttendance">
      <div class="icon-container">
        <i class="fa fa-question"></i>
      </div>
      <div class="alert-content">
        <div class="row">
          <div class="col-sm-6">
            <p class="lead m-b-none">Confirmation of attendance</p>
            <p class="no-margin" v-if="$userIsTalent">{{ user.name }}, please confirm you will be attending this event.</p>
            <p class="no-margin" v-else>Please confirm <strong>{{ user.name }}</strong> will be attending this event.</p>
          </div>
          <div class="col-sm-6">
            <button
              class="btn btn-lg btn-success btn-job-complete"
              @click="handleConfirmAttendanceCallback('in_person')">
              <template v-if="$userIsTalent"><i class="fa fa-check"></i> Yes, I am attending</template>
              <template v-else><i class="fa fa-check"></i> Yes, {{ $starLabel }} is attending</template>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="alert-large alert-large-info" v-if="bookingAppearanceOnline && !talentConfirmedOnlineParticipation">
      <div class="icon-container">
        <i class="fa fa-question"></i>
      </div>
      <div class="alert-content">
        <div class="row">
          <div class="col-sm-6">
            <p class="lead m-b-none">Online Deliverables: Confirmation of participation</p>
            <p class="no-margin" v-if="$userIsTalent">{{ user.name }}, please confirm you will be completing the online requirement for this booking.</p>
            <p class="no-margin" v-else>Please confirm <strong>{{ user.name }}</strong> will be completing the online requirement for this booking.</p>
          </div>
          <div class="col-sm-6">
            <button
              class="btn btn-lg btn-success btn-job-complete"
              @click="handleConfirmAttendanceCallback('online')">
              <template v-if="$userIsTalent"><i class="fa fa-check"></i> Yes, I will complete</template>
              <template v-else><i class="fa fa-check"></i> Yes, {{ $starLabel }} will complete</template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { notify } from 'utils'
import { helpers } from 'mixins/bookings'

export default {
  mixins: [helpers],

  props: {
    user: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapState('booking', ['booking']),

    talentConfirmedInPersonAttendance () {
      return this.user.response.attendance_confirmed
    },

    talentConfirmedOnlineParticipation () {
      return this.user.response.online_participation_confirmed
    }
  },

  methods: {
    ...mapActions('booking', ['confirmTalentAttendance', 'replaceBookingTalent']),

    /**
     * Handle confirming attendance.
     *
     * @return Promise
     */
    handleConfirmAttendanceCallback (type) {
      const payload = {
        bookingId: this.booking.id,
        talentId: this.user.id,
        type: type
      }

      return this.confirmTalentAttendance(payload)
        .then((response) => {
          this.replaceBookingTalent({ id: this.user.id, talent: response.data })
        })
        .then(() => {
          if (this.$userIsAdmin) {
            if (this.bookingAppearanceInPerson) {
              notify.success(`Attendance confirmed for ${this.user.name}.`)
            } else {
              notify.success(`Completion confirmed for ${this.user.name}.`)
            }
          } else {
            if (this.bookingAppearanceInPerson) {
              notify.success('Your attendance has been confirmed.')
            } else {
              notify.success('Your completion has been confirmed.')
            }
          }
        })
    }
  }
}
</script>
